export default "__VITE_ASSET__CEBKx74x__"